<template>
  <b-form-checkbox
    class="mb-2 text-nowrap"
    id="sameAsBilling"
    v-model="model"
    :value="true"
    :unchecked-value="false"
    @change="inputChange"
    :rules="required ? 'required' : ''"
  >
    {{ computedLabel }}
  </b-form-checkbox>
</template>

<script>
import BaseInputMixin from "../../../../mixins/signupInputMixin";
import {mapMutations, mapState} from "vuex";

export default {
  name: "ShippingSameAsBillingAddress",
  mixins: [BaseInputMixin('same_as_billing')],

  data() {
    return {
      defaultLabel: this.$t("Same As Billing Address")
    }
  },
  computed: {
    ...mapState(['signup'])
  },
  methods: {
    ...mapMutations(['signupFieldOnInput']),
    inputChange(val) {
      if (val) {
        this.signupFieldOnInput({field: 'shipping_address', value: this.signup.model.billing_address})
      }
    }
  }
}
</script>

<style scoped>

</style>
